import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Table as MuiTable,
  TableContainer as MuiTableContainer,
  TextField,
  Toolbar,
} from "@material-ui/core";
import { InfoRounded, Search } from "@material-ui/icons";

import ExcelLogo from "assets/img/excel_icon.svg";
import disableExcelLogo from "assets/img/greyexcel_icon.svg";
import disablePdfLogo from "assets/img/greypdf_icon.svg";

import RedExcelLogo from "assets/img/excelattendance_icon.svg";
import PdfLogo from "assets/img/pdf_icon.svg";
import TablePagination from "@Components/Table/TablePagination";
import EnhancedTableHead from "components/Table/EnhancedTableHead";
import NoDataRow from "@Components/Table/NoDataRow";
import TableBody from "components/Table/TableBody";
import useStyles from "assets/jss/material-dashboard-react/components/customTableStyle";
import LoadingOverlay from "react-loading-overlay";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import HoverTooltip from "components/Tooltip/HoverTooltip";
import BlockIcon from "@material-ui/icons/Block";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";

const removeDuplicates = (data, key) => {
  return [...new Map(data.map((item) => [key(item), item])).values()];
};

const TableContainer = (props) => {
  const { classes } = props;
  return (
    <MuiTableContainer component={Paper}>
      <MuiTable className={classes.table} size="small">
        {/* eslint-disable-next-line react/prop-types */}
        {props.children}
      </MuiTable>
    </MuiTableContainer>
  );
};
TableContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

const MyTable = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  let {
    refreshData,
    config,
    hideToolbar,
    headCells,
    records,
    search,
    setConfirmDialog,
    actions,
    tableButton,
    excelExport,
    emailExcelExport,
    pageNumberDropdown,
    filters,
    headCheckBox,
    headCheckBoxCallback,
    checkBox,
    checkBoxCallback,
    loading,
    setLoading,
    page,
    setPage,
    pageSize,
    setPageSize,
    totalRecords,
    linkUrlName,
    sortingCallback,
    setSelectedEmployeeId,
    viewDetailsPermission,
    editPermission,
    showInfoIcon,
    infoContent,
    paginationDisable,
    tableBodyDisable,
    grandTotalEnable,
    pdfExport,
    disablePdfExport,
    disableExcelExport,
    disableLabelDisplayedRows,


  } = props;
  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [topCheckBox, setTopCheckBox] = useState(headCheckBox);
  const [itemCheckBox, setItemCheckBox] = useState(checkBox);
  const [selectedPage, setSelectedPage] = useState(1);


  // eslint-disable-next-line no-unused-vars
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  if (
    checkBox === undefined ||
    checkBoxCallback === undefined ||
    headCheckBox === undefined ||
    headCheckBoxCallback === undefined
  ) {
    headCheckBox = undefined;
    headCheckBoxCallback = undefined;
    checkBox = undefined;
    checkBoxCallback = undefined;
  }

  // State used to display loading overlay over table
  const actionsColumn = { id: "actions", label: t("Action") };

  const handleRequestSort = (event, property, field) => {
    const isAsc = orderBy === property && order === "desc";
    setOrder(isAsc ? "asc" : "desc");
    setOrderBy(property);
    sortingCallback
      ? sortingCallback({
        sortingKey: field ? property + "__" + field : property,
        sortingType: isAsc ? "asc" : "desc",
      })
      : null;
  };
  const handlePageChange = (event) => {
    setPage(parseInt(event.target.value, 10));
  };
  const handleSearch = () => {
    // eslint-disable-next-line no-undef
    let targetValue = searchValue.toLowerCase();
    setFilterFn({
      fn: (items) => {
        if (targetValue === "") return items;
        else
          return items.filter((x) =>
            x.name.toLowerCase().includes(targetValue)
          );
      },
    });
  };

  const recordsAfterPagingAndSorting = () => {
    // stableSort(filterFn.fn(records), getComparator(order, orderBy));
    return records;
  };

  if (actions) {
    headCells.push(actionsColumn);
  }
  const updatedHeadCells = removeDuplicates(headCells, (item) => item.id);

  const updatedRecords = recordsAfterPagingAndSorting().map((record) =>
    actions
      ? {
        ...record,
        actions: (
          <>

            {
              actions.map((action) => {
                if ("renderKey" in action && record[action.renderKey] !== action.renderValue) {
                  return null;
                }
                if (action.type === "download" && record.banner_type !== "PB") {
                  return null; // Skip rendering the "Download" action if banner_type is not "PB"
                }
                // commenting out the approve and decline icons as they are not need for pending profile update
                // if (action.type === "approve" && record.active_approval_request === false) {
                //   return (
                //     <CheckCircleOutlineIcon key={`approve-icon-${record.id}`} style={{ color: "grey" }} />
                //   );
                // }
                // if (action.type === "decline" && record.active_approval_request === false) {
                //   return (
                //     <BlockIcon key={`decline-icon-${record.id}`} style={{ color: "grey" }} />
                //   );
                // }
                return (
                  <IconButton
                    className={clsx(classes.actionButtonRoot, {
                      [classes["delete"]]: action.type === "delete",
                    })}
                    onClick={
                      action.type === "delete"
                        ? () =>
                          setConfirmDialog({
                            isOpen: true,
                            title: "Are you sure to delete this record?",
                            subTitle: "YOU CANNOT UNDO THIS OPERATION",
                            onConfirm: () => {                                                    
                              action.onClick(record.id);
                            },
                          })
                        : () => {
                          action.onClick(record.id, record);
                          setTimeout(function () {
                            refreshData(config);
                          }, 500);
                        }
                    }
                    key={action.type}
                    type={action.type}
                    title={t(action.title)}
                  >
                    {action.icon}
                  </IconButton>
                );
              })
            }

          </>
        ),
      }
      : record
  );

  useEffect(() => {
    setItemCheckBox(checkBox);
  }, [checkBox]);

  useEffect(() => {
    setTopCheckBox(headCheckBox);
  }, [headCheckBox]);

  return (
    <>
      <Paper className={classes.pageContent}>
        {!hideToolbar ? (
          <Toolbar className={classes.toolbar}>
            <Grid
              container
              direction="row"
              spacing={3}
              alignItems="center"
              justify="flex-end"
            >
              {search ? (
                <Grid container item spacing={1} xs={12} sm={12} md={6} lg={6}>
                  <Grid item xs={12} sm={9} md={9} lg={9}>
                    <TextField
                      variant="outlined"
                      size="small"
                      placeholder={t("Search")}
                      className={classes.searchInput + " " + classes.toolbarSearch}
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(event) => setSearchValue(event.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={3} md={3} lg={3}>
                    <Button
                      className={classes.toolbarSearch}
                      startIcon={<Search />}
                      color="primary"
                      variant="contained"
                      onClick={handleSearch}
                    >
                      {t("search")}
                    </Button>
                  </Grid>
                </Grid>
              ) : null}

              <Grid
                item
                container
                direction="row"
                alignItems="center"
                spacing={1}
                xs={12}
                className={classes.toolbarActionContainer}
              >
                <div style={{ flex: 1 }}>
                  {pageNumberDropdown ? (
                    <div>
                      <b>
                        <span>Page No: </span>
                      </b>
                      <select value={page} onChange={handlePageChange}>
                        {Array.from(
                          { length: Math.ceil(totalRecords / pageSize) },
                          (_, index) => {
                            const pageNumber = index;

                            return (
                              <option key={index} value={pageNumber}>
                                {pageNumber + 1}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                  ) : null}
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  {showInfoIcon ? (
                    <HoverTooltip title={infoContent}>
                      <IconButton style={{ margin: "10px" }}>
                        <InfoRounded
                          style={{ position: "absolute", fontSize: "30px" }}
                          color="primary"
                        />
                      </IconButton>
                    </HoverTooltip>
                  ) : null}
                  {tableButton
                    ? tableButton.map((button, idx) => {
                      return (
                        <Grid item key={idx} style={{ marginRight: "4px" }}>
                          <Button
                            variant="contained"
                            style={{ textTransform: "capitalize" }}
                            onClick={button.onClick}
                            color={button.color}
                            startIcon={button.startIcon ? button.startIcon : null}
                            disabled={button.disabled ? button.disabled : false}
                          >
                            {t(button.buttonLabel)}
                          </Button>
                        </Grid>
                      );
                    })
                    : null}

                  {excelExport ? (
                    <IconButton
                      style={{ marginRight: "4px" }}
                      onClick={excelExport}
                    >
                      <img src={ExcelLogo} alt="excel_icon" />
                    </IconButton>
                  ) : null}
                  {emailExcelExport ? (
                    <IconButton
                      style={{ marginRight: "4px" }}
                      onClick={emailExcelExport}
                    >
                      <img src={RedExcelLogo} alt="excel_icon" />
                    </IconButton>
                  ) : null}
                  {disableExcelExport ? (
                    <IconButton
                      style={{ marginRight: "4px" }}
                    >
                      <img src={disableExcelLogo} alt="greyexcel_icon" />
                    </IconButton>
                  ) : null}
                  {disablePdfExport ? (
                    <IconButton
                      style={{ marginRight: "4px" }}
                    >
                      <img src={disablePdfLogo} alt="greypdf_icon" />
                    </IconButton>
                  ) : null}
                  {pdfExport ? (
                    <IconButton
                      style={{ marginRight: "4px" }}
                      onClick={pdfExport}
                    >
                      <img src={PdfLogo} alt="pdf_icon" />
                    </IconButton>
                  ) : null}
                  
                </div>
              </Grid>
            </Grid>
          </Toolbar>
        ) : null}


        {/*Loading overlay to mask the table while data is loading*/}
        <LoadingOverlay
          styles={{
            overlay: (base) => ({
              ...base,
              background: "rgba(0, 0, 0, 0.2)",
            }),
          }}
          active={loading}
          spinner={<LoadingIcon />}
        >
          <TableContainer classes={classes}>
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              updatedHeadCells={updatedHeadCells}
              checkBox={topCheckBox}
              setChecked={headCheckBoxCallback}
              setEmployeeId={setSelectedEmployeeId}
            />
            {records.length && !tableBodyDisable ? (
              <TableBody
                classes={classes}
                filters={filters}
                updatedRecords={updatedRecords}
                updatedHeadCells={updatedHeadCells}
                setLoading={setLoading}
                checkBox={itemCheckBox}
                setChecked={checkBoxCallback}
                setEmployeeId={setSelectedEmployeeId}
                viewDetailsPermission={viewDetailsPermission}
                editPermission={editPermission}
                grandTotalEnable={grandTotalEnable}
                linkUrlName={linkUrlName}
              />
            ) : !tableBodyDisable ? (
              <NoDataRow noOfCols={headCells.length} />
            ) : null}


          </TableContainer>

          {!paginationDisable ? (

            <TablePagination
              page={page}
              setPage={setPage}
              rowsPerPage={pageSize}
              setRowsPerPage={setPageSize}
              refreshData={refreshData}
              config={config}
              totalRecords={totalRecords}
              disableLabelDisplayedRows = {disableLabelDisplayedRows}

            />
          ) : (
            null
          )}


        </LoadingOverlay>
      </Paper>
    </>
  );
};

MyTable.propTypes = {
  refreshData: PropTypes.func,
  config: PropTypes.object,
  headCells: PropTypes.array,
  records: PropTypes.array,
  search: PropTypes.bool,
  setConfirmDialog: PropTypes.func,
  actions: PropTypes.array,
  tableButton: PropTypes.array,
  excelExport: PropTypes.func,
  emailExcelExport: PropTypes.func,
  pdfExport: PropTypes.func,
  disablePdfExport: PropTypes.func,
  disableExcelExport: PropTypes.func,
  showInfoIcon: PropTypes.bool,
  pageNumberDropdown: PropTypes.bool,
  paginationDisable: PropTypes.bool,
  tableBodyDisable: PropTypes.bool,
  grandTotalEnable: PropTypes.bool,
  hideToolbar: PropTypes.bool,
  filters: PropTypes.array,
  headCheckBox: PropTypes.bool,
  headCheckBoxCallback: PropTypes.func,
  checkBox: PropTypes.array,
  checkBoxCallback: PropTypes.func,
  EmployeSelectCallback: PropTypes.func,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func,
  pageSize: PropTypes.number,
  setPageSize: PropTypes.func,
  totalRecords: PropTypes.number,
  linkUrlName: PropTypes.string,
  sortingCallback: PropTypes.func,
  setSelectedEmployeeId: PropTypes.func,
  viewDetailsPermission: PropTypes.bool,
  editPermission: PropTypes.bool,
  infoContent: PropTypes.string,
  disableLabelDisplayedRows: PropTypes.bool,


};

export default MyTable;
